<div class="error-wrapper">
  <div>
    <div class="number">500</div>
    <div class="message">System maintenance in progress!</div>
  </div>
</div>